import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { PagesFilterModel } from "./pages-filter.model";
import { PagesFilterService } from "./pages-filter.service";
import { TipoDataEnum } from "../../models/tipo-data-enum.model";
import { StatusCertificadoEnum } from "../../models/status-certificado-enum.model";
import { StatusHopeEnum } from "../../models/status-hope-enum.model";
import { PagesFilterStorageService } from "../../services/pages-filter-storage.service";
import { Router } from "@angular/router";
import { AppSettings } from "../../../app.settings";
import {
  IMultiSelectOption,
  IMultiSelectSettings,
  IMultiSelectTexts,
  MultiselectDropdownComponent,
} from "angular-2-dropdown-multiselect";
import { DropdownListService } from "../../services/dropdownlist.service";
import { TipoEmissaoEnum } from "../../models/tipo-emissao-enum.model";
import { Util } from "../../utils/util";

@Component({
  // tslint:disable-next-line:component-selector
  selector: "pages-filter",
  templateUrl: "./pages-filter.component.html",
  styleUrls: ["./pages-filter.component.scss"],
})
export class PagesFilterComponent implements OnInit {
  @ViewChild("multiselectAR", { static: false })
  private multiselectAR: MultiselectDropdownComponent;
  @ViewChild("multiselectLA", { static: false })
  private multiselectLA: MultiselectDropdownComponent;
  @ViewChild("multiselectAGR", { static: false })
  private multiselectAGR: MultiselectDropdownComponent;
  @ViewChild("multiselectStatusACI", { static: false })
  private multiselectStatusACI: MultiselectDropdownComponent;
  @ViewChild("multiselectStatusCertificado", { static: false })
  private multiselectStatusCertificado: MultiselectDropdownComponent;
  @ViewChild("multiselectTipoEmissao", { static: false })
  private multiselectTipoEmissao: MultiselectDropdownComponent;
  @ViewChild("multiselectTipoIdentificacao", { static: false })
  private multiselectTipoIdentificacao: MultiselectDropdownComponent;

  // Listas utilizadas nos filtros
  listaProdutos = [];
  listaProdutoTipos = [];
  listaProdutoModelos = [];
  listaProdutoValidades = [];
  listaACs = [];
  listaACsMultiSelect = [];
  listaARsHabilitados = [];
  listaARsDesabilitados = [];
  listaARsMultiSelect = [];
  listaLocaisHabilitados = [];
  listaLocaisDesabilitados = [];
  listaLocaisMultiSelect = [];
  listaAGR = [];
  listaAGRMultiSelect = [];
  listaACIStatus = [];
  listaTipoEmissaoMultiSelect = [];
  listaTipoIdentificacaoMultiSelect = [];
  listaParceiro = [];

  // identificador fixo dos labels de informação no multiSelect
  private idHabilitados = 999999;
  private idDesabilitados = 888888;

  // Lista de enums
  listaTipoData;
  listaCertificadoStatus;
  listaHopeStatus;

  // Configuração do template
  _templateConfig = new PagesFilterModel();

  // Configurações do multiselect
  public controlsSettings: IMultiSelectSettings = {
    checkedStyle: "fontawesome",
    buttonClasses: "btn btn-secondary btn-block",
    dynamicTitleMaxItems: 1,
    displayAllSelectedText: true,
    showCheckAll: true,
    showUncheckAll: true,
    enableSearch: true,
  };

  // Inputs
  @Input() group: FormGroup;
  @Input("config")
  set config(config: PagesFilterModel) {
    this._templateConfig = Object.assign(this._templateConfig, config);
  }
  @Input("tipoDataList")
  set tipoDataList(tipoDataList: TipoDataEnum[]) {
    // Carrega a lista de tipoData do filtro
    this.listaTipoData = TipoDataEnum.values(tipoDataList);
  }
  // Outputs
  @Output() search = new EventEmitter();
  @Output() exportFile = new EventEmitter();
  @Output() cleanFilters = new EventEmitter();

  constructor(
    private service: PagesFilterService,
    private dropdownlistService: DropdownListService,
    private filterStorageService: PagesFilterStorageService,
    private router: Router,
    public appSettings: AppSettings
  ) {
    this.listaCertificadoStatus = StatusCertificadoEnum.values();
    this.listaHopeStatus = StatusHopeEnum.values();
  }

  ngOnInit() {
    // Carrega as ACs se configurado
    if (this._templateConfig.showAutoridadeCertificadora) {
      this.dropdownlistService
        .getAutoridadeCertificadoraDropdownList()
        .subscribe((result) => {
          if (result) {
            if (!this._templateConfig.isMultiSelect) {
              this.listaACs = result;
              this.group.get("idAutoridadeCertificadora").setValue(-1);
            } else {
              this.listaACsMultiSelect = result.map((x) => {
                return { id: x.idAutoridadeCertificadora, name: x.Nome };
              });
            }
          }
        });
    }

    // Carrega os tipos de produtos se configurado
    if (this._templateConfig.showProdutoTipo) {
      this.service.getListTipos().subscribe((result) => {
        this.listaProdutoTipos = result;
      });
    }

    // Carrega os modelos de produtos se configurado
    if (this._templateConfig.showProdutoModelo) {
      this.service.getListModelos().subscribe((result) => {
        this.listaProdutoModelos = result;
      });
    }

    // Carrega os validades de produtos se configurado
    if (this._templateConfig.showProdutoValidade) {
      this.service.getListValidades().subscribe((result) => {
        this.listaProdutoValidades = result;
      });
    }

    // Carrega os tipos de emissão se configurado
    if (this._templateConfig.showTipoEmissao) {
      this.service.getListTipoEmissao().subscribe((result) => {
        var tipoExibidos = result
          .map((x) => {
            return { id: x.idTipoEmissao, name: x.Nome };
          })
          .filter((x) => x.id != TipoEmissaoEnum.EmissaoAutonoma);

        this.listaTipoEmissaoMultiSelect =
          Util.renomeiaTipoEmissao(tipoExibidos);
      });
    }

    // Carrega os tipos de identificação se configurado
    if (this._templateConfig.showTipoIdentificacao) {
      this.service.getListTipoIdentificacao().subscribe((result) => {
        var tipoExibidos = result
          .map((x) => {
            return { id: x.idTipoIdentificacao, name: x.Nome };
          })
          .filter((x) => x.id != TipoEmissaoEnum.EmissaoAutonoma);

        this.listaTipoIdentificacaoMultiSelect =
          Util.renomeiaTipoEmissao(tipoExibidos);
      });
    }

    // Carrega os Status do ACI se configurado
    if (this._templateConfig.showStatusACI) {
      this.service.getListStatusACI().subscribe((result) => {
        if (result) {
          this.listaACIStatus = result.map((x) => {
            return { id: x.idDossieStatus, name: x.Descricao };
          });
        }
      });
    }

    // Carrega os Status do Certificado se configurado
    if (this._templateConfig.showStatusCertificado) {
      this.listaCertificadoStatus = this.listaCertificadoStatus.map((x) => {
        return { id: x.enum, name: x.description };
      });
    }

    // Carrega os Status do Hope se configurado
    if (this._templateConfig.showStatusHope) {
      this.listaHopeStatus = this.listaHopeStatus.map((x) => {
        return { id: x.enum, name: x.description };
      });
    }

    // Carrega os Parceiro se configurado
    if (this._templateConfig.showParceiro) {
      this.service.getParceiros().subscribe((ars) => {
        this.listaParceiro = ars.map((x) => {
          return { id: x.idParceiro, name: x.Nome };
        });
      });
    }
  }

  onChangeLA(idLocalAtendimento: number) {
    if (idLocalAtendimento > 0) {
      // Carrega os AGRs se configurado
      if (
        this._templateConfig.showAgenteRegistro &&
        !this._templateConfig.isMultiSelect
      ) {
        // Caso não seja multiselect
        this.service
          .getDropdownListAgenteRegistro([idLocalAtendimento])
          .subscribe((result) => {
            if (result) {
              // Popula a lista de agentes de registro
              this.listaAGR = result;
              this.group.get("idAgenteRegistro").setValue(-1);
            }
          });
      }
    } else {
      this.listaAGR = [];
    }
  }

  onChangeMultipleLA(idsLocalAtendimento: []) {
    if (idsLocalAtendimento && idsLocalAtendimento.length > 0) {
      // Limpa os ids dos agrupamentos
      idsLocalAtendimento = this.cleanIsLabelIds(idsLocalAtendimento);

      // Carrega os AGRs se configurado
      if (this._templateConfig.showAgenteRegistro) {
        this.listaAGR = [];
        this.service
          .getDropdownListAgenteRegistro(idsLocalAtendimento)
          .subscribe((result) => {
            if (result) {
              // Popula a lista de agentes de registro
              this.listaAGR = this.listaAGR.concat(result);
              // Ajusta a lista caso seja multiSelect
              if (this._templateConfig.isMultiSelect) {
                this.listaAGRMultiSelect = [];
                this.listaAGRMultiSelect = this.listaAGR.map((x) => {
                  return { id: x.idAgenteRegistro, name: x.Nome };
                });
              } else {
                this.group.get("idAgenteRegistro").setValue(-1);
              }
            }
          });
      }
    } else {
      this.multiselectAGR.uncheckAll();
      this.listaAGR = this.listaAGRMultiSelect = [];
    }
  }

  onChangeAR(idAutoridadeRegistro: number) {
    if (idAutoridadeRegistro > 0) {
      // Carrega os LAs se configurado
      if (this._templateConfig.showLocalAtendimento) {
        this.dropdownlistService
          .getLocalAtendimentoDropdownListByAR(idAutoridadeRegistro)
          .subscribe((result) => {
            if (result) {
              // Popula a lista de locais habilitados
              this.listaLocaisHabilitados = result.filter(
                (x) => x.Status !== 2
              );
              // Popula a lista de locais desabilitados
              this.listaLocaisDesabilitados = result.filter(
                (x) => x.Status === 2
              );
              this.group.get("idLocalAtendimento").setValue(-1);
            }
          });
      }
    } else {
      this.listaAGR =
        this.listaLocaisHabilitados =
        this.listaLocaisDesabilitados =
          [];
    }
  }

  onChangeMultipleAR(idsAutoridadeRegistro: []) {
    if (idsAutoridadeRegistro && idsAutoridadeRegistro.length > 0) {
      // Limpa os ids dos agrupamentos
      idsAutoridadeRegistro = this.cleanIsLabelIds(idsAutoridadeRegistro);

      // Carrega os LAs se configurado
      if (this._templateConfig.showLocalAtendimento) {
        this.listaLocaisHabilitados = this.listaLocaisDesabilitados = [];
        idsAutoridadeRegistro.forEach((idAr) => {
          this.dropdownlistService
            .getLocalAtendimentoDropdownListByAR(idAr)
            .subscribe((result) => {
              if (result) {
                // Popula a lista de locais habilitados
                this.listaLocaisHabilitados =
                  this.listaLocaisHabilitados.concat(
                    result.filter((x) => x.idStatus !== 2)
                  );
                // Popula a lista de locais desabilitados
                this.listaLocaisDesabilitados =
                  this.listaLocaisDesabilitados.concat(
                    result.filter((x) => x.idStatus === 2)
                  );
              }
            });
        });

        // Ajusta a lista caso seja multiSelect
        if (this._templateConfig.isMultiSelect) {
          this.listaLocaisMultiSelect = [];
          // Monta os habilitados
          this.listaLocaisMultiSelect = [
            {
              id: this.idHabilitados,
              name: "Habilitados ou Suspensos",
              isLabel: true,
            },
          ];
          this.listaLocaisMultiSelect = this.listaLocaisMultiSelect.concat(
            this.listaLocaisHabilitados
              .filter((local) => local.idStatus !== 2)
              .map((local) => {
                return {
                  id: local.idLocalAtendimento,
                  name: local.Nome,
                  parentId: this.idHabilitados,
                };
              })
          );

          // Monta os desabilitados
          this.listaLocaisMultiSelect.push({
            id: this.idDesabilitados,
            name: "Desabilitados",
            isLabel: true,
          });
          this.listaLocaisMultiSelect = this.listaLocaisMultiSelect.concat(
            this.listaLocaisDesabilitados
              .filter((local) => local.idStatus === 2)
              .map((local) => {
                return {
                  id: local.idLocalAtendimento,
                  name: local.Nome,
                  parentId: this.idDesabilitados,
                };
              })
          );
        } else {
          this.group.get("idLocalAtendimento").setValue(-1);
        }
      }
    } else {
      this.listaAGR =
        this.listaAGRMultiSelect =
        this.listaLocaisHabilitados =
        this.listaLocaisDesabilitados =
        this.listaLocaisMultiSelect =
          [];
    }
  }

  onChangeAC(idAutoridadeCertificadora: number) {
    if (idAutoridadeCertificadora > 0) {
      // Carrega os produtos se configurado
      if (this._templateConfig.showProduto) {
        this.service
          .getListProdutos(idAutoridadeCertificadora)
          .subscribe((result) => {
            if (result) {
              this.listaProdutos = result;
              this.group.get("idProduto").setValue(-1);
            }
          });
      }

      // Carrega as ARs se configurado
      if (this._templateConfig.showAutoridadeRegistro) {
        this.dropdownlistService
          .getAutoridadeRegistroDropdownListByAC(idAutoridadeCertificadora)
          .subscribe((result) => {
            if (result) {
              // Popula a lista de autoridades habilitadas
              this.listaARsHabilitados = result.filter((x) => {
                if (x.Status !== 2) {
                  return x;
                }
              });
              // Popula a lista de autoridades desabilitadas
              this.listaARsDesabilitados = result.filter((x) => {
                if (x.Status === 2) {
                  return x;
                }
              });
              this.group.get("idAutoridadeRegistro").setValue(-1);
            }
          });
      }
    } else {
      this.listaProdutos =
        this.listaAGR =
        this.listaLocaisHabilitados =
        this.listaLocaisDesabilitados =
        this.listaARsHabilitados =
        this.listaARsDesabilitados =
          [];
    }
  }

  onChangeMultipleAC(idsAutoridadeCertificadora: []) {
    if (idsAutoridadeCertificadora && idsAutoridadeCertificadora.length > 0) {
      // Carrega os produtos se configurado
      if (this._templateConfig.showProduto) {
        this.listaProdutos = [];
        idsAutoridadeCertificadora.forEach((idAc) => {
          this.service.getListProdutos(idAc).subscribe((result) => {
            if (result) {
              this.listaProdutos = this.listaProdutos.concat(result);
              this.group.get("idProduto").setValue(-1);
            }
          });
        });
      }

      // Carrega as ARs se configurado
      if (this._templateConfig.showAutoridadeRegistro) {
        this.listaARsHabilitados = this.listaARsDesabilitados = [];
        idsAutoridadeCertificadora.forEach((idAr) => {
          this.dropdownlistService
            .getAutoridadeRegistroDropdownListByAC(idAr)
            .subscribe((result) => {
              if (result) {
                // Popula a lista de autoridades habilitadas
                this.listaARsHabilitados = this.listaARsHabilitados.concat(
                  result.filter((x) => x.idStatus !== 2)
                );
                // Popula a lista de autoridades desabilitadas
                this.listaARsDesabilitados = this.listaARsDesabilitados.concat(
                  result.filter((x) => x.idStatus === 2)
                );
              }
            });
        });

        // Ajusta a lista caso seja multiSelect
        if (this._templateConfig.isMultiSelect) {
          this.listaARsMultiSelect = [];
          // Monta os habilitados
          this.listaARsMultiSelect = [
            {
              id: this.idHabilitados,
              name: "Habilitados ou Suspensos",
              isLabel: true,
            },
          ];
          this.listaARsMultiSelect = this.listaARsMultiSelect.concat(
            this.listaARsHabilitados
              .filter((autoridade) => autoridade.idStatus !== 2)
              .map((autoridade) => {
                return {
                  id: autoridade.idAutoridadeRegistro,
                  name: autoridade.Nome,
                  parentId: this.idHabilitados,
                };
              })
          );

          // Monta os desabilitados
          this.listaARsMultiSelect.push({
            id: this.idDesabilitados,
            name: "Desabilitados",
            isLabel: true,
          });
          this.listaARsMultiSelect = this.listaARsMultiSelect.concat(
            this.listaARsDesabilitados
              .filter((autoridade) => autoridade.idStatus === 2)
              .map((autoridade) => {
                return {
                  id: autoridade.idAutoridadeRegistro,
                  name: autoridade.Nome,
                  parentId: this.idDesabilitados,
                };
              })
          );
        } else {
          this.group.get("idAutoridadeRegistro").setValue(-1);
        }
      }
    } else {
      this.multiselectAR.uncheckAll();
      this.listaAGR =
        this.listaAGRMultiSelect =
        this.listaLocaisHabilitados =
        this.listaLocaisDesabilitados =
        this.listaARsHabilitados =
        this.listaARsDesabilitados =
        this.listaARsMultiSelect =
          [];
    }
  }

  /**
   * Método responsável por criar a configuração das listas de multiplas seleção.
   * @param title Titulo que será exibida na lista.
   */
  public getConfigSelectTexts(title: string) {
    const controlsText: IMultiSelectTexts = {
      checkAll: "Marcar todos",
      uncheckAll: "Desmarcar todos",
      checked: "Item selecionado",
      checkedPlural: "Itens selecionados",
      searchPlaceholder: "Procurar",
      searchEmptyResult: "Nada encontrado...",
      searchNoRenderText: "Digite para ver resultados...",
      defaultTitle: title,
      allSelected: "Todos selecionados",
    };
    return controlsText;
  }

  /**
   * Método responsável por inicializar os filtros de data de validade.
   */
  // private initDates() {
  //     const dateNow = new Date();
  //     const firstDay = new Date(dateNow.getFullYear(), dateNow.getMonth() + 1, 1);
  //     const lastDay = new Date(dateNow.getFullYear(), dateNow.getMonth() + 2, 0);
  //     // this.formFiltro.get('DtInicioValidade').setValue(firstDay);
  //     // this.formFiltro.get('DtFimValidade').setValue(lastDay);
  // }

  limparFiltros() {
    const control = this.group.get("QuantidadePorPagina");
    this.group.reset();
    // Volta os drops para selecione
    if (this._templateConfig.showAutoridadeCertificadora) {
      if (!this._templateConfig.isMultiSelect) {
        this.group.get("idAutoridadeCertificadora").setValue(-1);
      }
    }
    // Valida se o tipo data está exibido
    if (this._templateConfig.showTipoData) {
      this.group.get("TipoData").setValue(-1);
    }
    // Valida se o status está exibido
    if (this._templateConfig.showStatusProtocolo) {
      this.group.get("CertificadoStatus").setValue(-1);
    }
    // Valida se o tipo de emissão está exibido
    if (this._templateConfig.showTipoEmissao) {
      this.multiselectTipoEmissao.uncheckAll();
    }
    // Valida se o tipo de identificação está exibido
    if (this._templateConfig.showTipoIdentificacao) {
      this.multiselectTipoIdentificacao.uncheckAll();
    }
    // Valida se o status do hope está exibido
    if (this._templateConfig.showStatusHope) {
      this.group.get("HopeStatus").setValue(-1);
    }
    // Valida se o status está exibido
    if (this._templateConfig.showStatusSolicitacao) {
      this.group.get("SolicitacaoStatus").setValue(-1);
    }
    // Valida se o status ACI está exibido
    if (this._templateConfig.showStatusACI) {
      this.multiselectStatusACI.uncheckAll();
    }
    // Valida se o status do Certificado está exibido
    if (this._templateConfig.showStatusCertificado) {
      this.multiselectStatusCertificado.uncheckAll();
    }
    // Valida se o filtro de validação externa está exibido
    if (this._templateConfig.showValidacaoExterna) {
      this.group.get("isFormaValidacao").setValue(-1);
    }
    // Valida se a autoridade de registro está exibido
    if (this._templateConfig.showAutoridadeRegistro) {
      if (this._templateConfig.isMultiSelect) {
        this.listaARsMultiSelect = [];
      } else {
        this.group.get("idAutoridadeRegistro").setValue(-1);
      }
    }
    // Valida se o local de atendimento está exibido
    if (this._templateConfig.showLocalAtendimento) {
      if (this._templateConfig.isMultiSelect) {
        this.listaLocaisMultiSelect = [];
      } else {
        this.group.get("idLocalAtendimento").setValue(-1);
      }
    }
    // Valida se o agente registro está exibido
    if (this._templateConfig.showAgenteRegistro) {
      if (this._templateConfig.isMultiSelect) {
        this.listaAGRMultiSelect = [];
      } else {
        this.group.get("idAgenteRegistro").setValue(-1);
      }
    }
    // Valida se o produto está exibido
    if (this._templateConfig.showProduto) {
      this.listaProdutos = [];
      this.group.get("idProduto").setValue(-1);
    }
    // Valida se o tipo produto está exibido
    if (this._templateConfig.showProdutoTipo) {
      this.group.get("idProdutoTipo").setValue(-1);
    }
    // Valida se o produto modelo está exibido
    if (this._templateConfig.showProdutoModelo) {
      this.group.get("idProdutoModelo").setValue(-1);
    }
    // Valida se o produto validade está exibido
    if (this._templateConfig.showProdutoValidade) {
      this.group.get("idProdutoValidade").setValue(-1);
    }
    // Verifica se possui paginação
    if (control) {
      this.group
        .get("QuantidadePorPagina")
        .setValue(this.appSettings.settings.configs.defaultQuantityByPage);
    }
    this.filterStorageService.deleteSession(this.router);
    this.cleanFilters.emit();
  }

  exportarExcel() {
    this.exportFile.emit();
  }

  pesquisar() {
    this.search.emit();
  }

  /**
   * Remove os ids das labels em caso de multiselect agrupado.
   * @param list Lista que deseja filtrar.
   */
  private cleanIsLabelIds(list: []) {
    return <any>(
      list.filter(
        (item) => item !== this.idHabilitados && item !== this.idDesabilitados
      )
    );
  }
}
